import React from "react";
import { node, bool, string, elementType, func } from "prop-types";
import FormGroup from "../FormGroup";
import Label from "../Label";
import FieldHint from "../FieldHint";
import ErrorLabel from "../ErrorLabel";
import Input from "../Input";
import FieldLink from "../FieldLink";
import { isString } from "../utils/predicates";
import pureFC from "../utils/pureFC";
import { spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityProps, utilityPropTypes } from "../props/utility";
import { sizingProps, sizingPropTypes } from "../props/sizing";

const FormField = ({
	label,
	required,
	hint,
	error = null,
	link,
	Control = Input,
	children,
	fieldClassName,
	inverted = false,
	onLabelClick,
	spacing = { ...spacingProps },
	utility = { ...utilityProps },
	sizing = { ...sizingProps },
	...props
}) => (
	<FormGroup
		required={required}
		className={fieldClassName}
		error={error}
		spacing={spacing}
		utility={utility}
		sizing={sizing}
	>
		{isString(label) ? (
			// eslint-disable-next-line react/destructuring-assignment
			<Label htmlFor={props.id} inverted={inverted} onClick={onLabelClick}>
				{label}
			</Label>
		) : (
			label
		)}
		{Control && (
			<Control {...props} error={error}>
				{children}
			</Control>
		)}
		{!Control && children}
		{isString(hint) ? <FieldHint>{hint}</FieldHint> : hint}
		{isString(error) ? <ErrorLabel>{error}</ErrorLabel> : error}
		{link && <FieldLink>{link}</FieldLink>}
	</FormGroup>
);

FormField.propTypes = {
	id: string,
	label: node,
	required: bool,
	hint: node,
	error: node,
	link: node,
	Control: elementType,
	children: node,
	fieldClassName: string,
	inverted: bool,
	onLabelClick: func,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	sizing: sizingPropTypes,
};

export default pureFC(FormField);
